if ($('.panel-item').length) {
  $(".panel-title").click(function () {
    $(this).toggleClass('panel-show');
  });
}
